/* eslint-disable react/display-name */
import View from './View';

export { default as View, getMoreScreenAuthSectionStyles } from './View';

export default View;
